<div class="row">
	<div [ngClass]="{'col-md-6': horizontal, 'col-12': vertical}" class="questionText">{{question.display_index}}. {{question.prompt}}</div>
	<div [ngClass]="{'col-md-6': horizontal, 'col-12': vertical}">
		<select class="browser-default form-control" (change)="setAnswer($event.target.value)">
			<option value="">Choose an option...</option>
			<option [value]="label.id" *ngFor="let label of labels" [selected]="isSelected(label)">{{label.label}}</option>
		</select>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/assessments/question-dropdown/question-dropdown.component.html